import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ErrorIndicator from '../ErrorIndicator';
import types from '../../types';
import {FormattedMessage} from "react-intl";

class ErrorBoundary extends Component {
  state = {hasError: false};

  static getDerivedStateFromError = error => {
    console.log('getDerivedStateFromError', {error});
    return {hasError: true};
  };

  componentDidCatch(error, errorInfo) {
    console.log('componentDidCatch', {error, errorInfo});
    this.setState({hasError: true});
  }

  render() {
    if (this.state.hasError) {
      return <ErrorIndicator/>
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  ...types.children,
};

export default ErrorBoundary;
